import Vue from 'vue'
import moment from 'moment-timezone'
const vueMoment = require('vue-moment')

Vue.use(vueMoment, {
  moment
})
